import { FC, ReactNode } from 'react'
import MonthlyPaymentTable from '@pages/Admin/CourseSettings/components/TariffCard/components/MonthlyPaymentTable/MonthlyPaymentTable'
import TooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import CourseDiscountModeFields from '../../../../../CourseDiscountModeFields'
import type { CrmLinkDiscountMode } from '../../../../../discountMode.utils'
import {
  getStreamCustomPeriodHint,
  STREAM_CUSTOM_PERIOD_PRICE_LOCKED_TOOLTIP,
  STREAM_CUSTOM_PERIOD_UNFIXED_PRICE_HINT,
} from '../../../../../monthlyCourseLinkDiscount.utils'
import CreateLinkNumberInput from '../../../../../CreateLinkNumberInput'
import classes from '../index.module.css'
import spclasses from '../../../../../../SetCourseClassDirectionModal/purchase.module.css'

export type StreamAdditionalCourseDiscountFieldsProps = {
  tariff: ICourseTariff
  discount: number
  discountMode: CrmLinkDiscountMode | null
  price: number
  value: number | null
  basePrice: number
  isPeriodFixed: boolean
  tariffType?: string | null
  onChangeDiscount: (value: string | number | null) => void
  onDiscountModeChange: (mode: CrmLinkDiscountMode | null) => void
  onChangePrice: (value: string | number | null) => void
}

/**
 * Скидка (discount_mode) и цена periodного доп. курса.
 */
const StreamAdditionalCourseDiscountFields: FC<
  StreamAdditionalCourseDiscountFieldsProps
> = ({
  tariff,
  discount,
  discountMode,
  price,
  value,
  basePrice,
  isPeriodFixed,
  tariffType,
  onChangeDiscount,
  onDiscountModeChange,
  onChangePrice,
}) => {
  const renewalDiscountSlot: ReactNode = isPeriodFixed ? (
    <CourseDiscountModeFields
      variant="renewal_only"
      value={discount || null}
      onChange={onChangeDiscount}
      discountMode={discountMode}
      onDiscountModeChange={onDiscountModeChange}
      fullBasePrice={basePrice}
    />
  ) : null

  return (
    <div className={classes.monthlyFields}>
      {!isPeriodFixed ? (
        <CourseDiscountModeFields
          variant="first_payment"
          value={discount || null}
          onChange={onChangeDiscount}
          discountMode={discountMode}
          onDiscountModeChange={onDiscountModeChange}
          fullBasePrice={basePrice}
        />
      ) : null}

      <div className={spclasses.inputWithLabel}>
        <div className={spclasses.inputLabel}>
          Ценообразование за периоды обучения
        </div>
        <MonthlyPaymentTable tariff={tariff} readOnly />
      </div>

      {renewalDiscountSlot}

      <div className={spclasses.inputWithLabel}>
        {isPeriodFixed ? (
          <>
            <CreateLinkNumberInput
              className={spclasses.input}
              title="Итого по доп. курсу"
              min={0}
              step={0.01}
              value={price}
              onChange={onChangePrice}
            />
            <div className={classes.priceDescription}>
              Период зафиксирован: укажите итоговую сумму по таблице
              ценообразования тарифа.
              {discount > 0
                ? ' Скидка выше применяется только к продлениям.'
                : ''}
            </div>
          </>
        ) : (
          <>
            <div className={spclasses.inputLabel}>Итого по доп. курсу</div>
            <TooltipWrapper
              placement="top"
              title={STREAM_CUSTOM_PERIOD_PRICE_LOCKED_TOOLTIP}
            >
              <span style={{ display: 'block', cursor: 'not-allowed' }}>
                <CreateLinkNumberInput
                  className={`${spclasses.input} ${spclasses.disabledInput}`}
                  min={0}
                  step={0.01}
                  value={price}
                  disabled
                />
              </span>
            </TooltipWrapper>
            <div className={classes.priceDescription}>
              {getStreamCustomPeriodHint(
                value,
                basePrice,
                discount,
                price,
                tariffType,
              )}
              <div style={{ marginTop: 4 }}>
                {STREAM_CUSTOM_PERIOD_UNFIXED_PRICE_HINT}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default StreamAdditionalCourseDiscountFields
